import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface UserResponse {
  id: string;
  identifiant: string;
  email: string;
  cle_secrete: string;
  nom_entreprise: string;
  accessLevel: number;
}

@Injectable({
  providedIn: 'root'
})
export class PaymentBackofficeService {

  private getBaseUrl(): string {
    // Dynamically resolve baseUrl to adapt to subdirectory hosting on Apache local server
    const path = "https://bataakhal.sentelecom.com/";
    return path + 'utils/index.php';
  }
  private getBaseUrlBackoffice(): string {
    // Dynamically resolve baseUrl to adapt to subdirectory hosting on Apache local server
    const path = "https://bataakhal.sentelecom.com/";
    return path + 'yoonoumoomsaymbirr/api';
  }
  // hybraine_paiement\utils
  private getBaseUrlADMIN(): string {
    // Dynamically resolve baseUrl to adapt to subdirectory hosting on Apache local server
    const path = "https://bataakhal.sentelecom.com/";
    return path + 'yoonoumoomsaymbirr/';
  }

  private getBaseUrlPartenaire(): string {
    // Dynamically resolve baseUrl to adapt to subdirectory hosting on Apache local server
    const path = "https://bataakhal.sentelecom.com/";
    return path + 'yoonoupartenaireyi/index.php';
  }


  constructor(private http: HttpClient) { }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  // ============ AUTHENTIFICATION ============

  login(credentials: { login: string; password_hash: string }): Observable<any> {
    const url = `${this.getBaseUrlBackoffice()}/checkAuthentification.php`;
    // console.log(url);
    const payload = {
      login: credentials.login,
      password: credentials.password_hash
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

  createAccount(credentials: { email: string; nom_entreprise: string, accessLevel: number }): Observable<any> {
    const url = `${this.getBaseUrlBackoffice()}/createAccount.php`;
    // console.log(url);
    const payload = {
      email: credentials.email,
      nom_entreprise: credentials.nom_entreprise,
      accessLevel: credentials.accessLevel
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }


  soppidieufeundikoo(credentials: { login: string; old_password_hash: string, new_password_hash: string }): Observable<any> {
    const url = `${this.getBaseUrl()}/soppidieufeundikoo`;
    const payload = {
      login: credentials.login,
      old_password: credentials.old_password_hash,
      new_password: credentials.new_password_hash
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

  // ============ TRANSACTIONS ============

  getAllPartners(): Observable<any> {
    const url = `${this.getBaseUrlBackoffice()}/getAllPartners.php`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token,
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

  getTransactions(dateDebut: string, dateFin: string): Observable<any> {
    const isPartenaire = sessionStorage.getItem('profil') === 'PARTENAIRE';
    const baseUrl = isPartenaire ? this.getBaseUrlPartenaire() : this.getBaseUrlBackoffice();
    const url = isPartenaire ? `${this.getBaseUrlPartenaire()}/getTransactionByUser` : `${this.getBaseUrlBackoffice()}/getTransactionByUser.php`;

    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token,
      dateDebut: dateDebut,
      dateFin: dateFin
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }


  getSamaSolde(): Observable<any> {
    const isPartenaire = sessionStorage.getItem('profil') === 'PARTENAIRE';
    const baseUrl = isPartenaire ? this.getBaseUrlPartenaire() : this.getBaseUrlBackoffice();
    const url = isPartenaire ? `${this.getBaseUrlPartenaire()}/getSamaSolde` : `${this.getBaseUrlBackoffice()}/getSamaSolde.php`;

    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }



  getSituationCompagnie(dateDebut: string, dateFin: string): Observable<any> {
    const url = `${this.getBaseUrlBackoffice()}/situationCompagnieByUser.php`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token,
      dateDebut: dateDebut,
      dateFin: dateFin
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }



  situationCompagnieActuelleByUser(dateDebut: string, dateFin: string): Observable<any> {
    const url = `${this.getBaseUrlBackoffice()}/situationCompagnieByUser.php`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token,
      dateDebut: dateDebut,
      dateFin: dateFin
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

  // ============ COMMISSIONS ============

  getCommissions(): Observable<any> {
    const url = `${this.getBaseUrlBackoffice()}/getCommissionnement.php`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

  updateCommission(id: number, taux: number): Observable<any> {
    const url = `${this.getBaseUrlBackoffice()}/updateCommissionnement.php`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token,
      id: id,
      taux: taux
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

  // ============ PARTNER ACCOUNTS MANAGEMENT ============

  getAllUsers(): Observable<any> {
    const url = `${this.getBaseUrlBackoffice()}/getUserPartenaire.php`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = { token: token };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

  getCommissionnementByUser(): Observable<any> {
    const url = `${this.getBaseUrlBackoffice()}/getCommissionnement.php`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = { token: token };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

  createPartnerAccount(name: string, email: string, accessLevel: number): Observable<any> {
    const url = `${this.getBaseUrlBackoffice()}/createAccount.php`;
    const payload = {
      name: name,
      email: email,
      accessLevel: accessLevel
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

  updatePartnerAccount(id: number, name: string, email: string, accessLevel: number): Observable<any> {
    const url = `${this.getBaseUrlBackoffice()}/updateAccount.php`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token,
      id: id,
      name: name,
      email: email,
      accessLevel: accessLevel
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

  deletePartnerAccount(id: number): Observable<any> {
    const url = `${this.getBaseUrlBackoffice()}/desableAccount.php`;
    const token = sessionStorage.getItem('samacaabiyoonwii') || '';
    const payload = {
      token: token,
      id: id
    };
    return this.http.post<any>(url, payload, { headers: this.getHeaders() });
  }

}
